module.exports = __webpack_public_path__ + "static/media/Hide.01664068.svg";